<template>
  <div>
    <el-dialog
        :visible.sync="dialogVisible"
        width="800px"
        :before-close="handleClose"
        class="notice-preview-dialog">
      <div class="dialog-content">
        <img :src="imageUrl" alt="" @click="toOpenUrl">
        <div class="never-prompt">不再提示</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "NoticePreviewDialog",
  props: {
    imageUrl: {
      type: String,
      default() {
        return '';
      }
    },
    link: {
      type: String,
      default() {
        return '';
      }
    }
  },
  data() {
    return {
      dialogVisible: false
    };
  },
  methods: {
    handleClose(done) {
      this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {
          });
    },
    // 关闭弹框
    closeDialog() {
      this.dialogVisible = false;
    },
    // 打开弹框
    openDialog() {
      this.dialogVisible = true;
    },
    toOpenUrl() {
      if (!this.link) {
        this.$message({
          type: 'warning',
          message: '暂无跳转链接'
        });
        return;
      }
      console.log("要跳转的链接");
      // window.open(this.link, "_blank");
    },
  }
}
</script>


<style lang="less" scoped>
::v-deep .notice-preview-dialog {
  padding: 0 !important;

  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__headerbtn {
    top: 20px;
    right: 20px;
    width: 24px;
    height: 24px;

    &:hover {
      .el-dialog__close {
        background: transparent;
      }
    }
  }

  .el-dialog__body {
    padding: 0;
  }
}

.dialog-content {
  width: 800px;
  height: 550px;
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
  }

  .never-prompt {
    position: absolute;
    right: 56px;
    top: 20px;
    height: 24px;
    line-height: 24px;
    font-size: 12px;
  }
}
</style>